
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import FormHelperText from './form-helper-text'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formhelpertext"
    }}>{`FormHelperText`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "helper-text"
    }}>{`Helper text`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For providing additional information about a form input.`}</p>
    <Playground __position={1} __code={'<FormHelperText text=\"Helper text\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormHelperText
    }} mdxType="Playground">
  <FormHelperText text="Helper text" mdxType="FormHelperText" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "helper-text-inverse"
    }}>{`Helper text (inverse)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For providing additional information about a form input.`}</p>
    <Playground __position={3} __code={'<FormHelperText inverse text=\"Helper text\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormHelperText
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <FormHelperText inverse text="Helper text" mdxType="FormHelperText" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormHelperText} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;